import React, { useState } from 'react';
import { Container, Card, CardContent, Typography, TextField, Button, Alert, Box } from '@mui/material';
import { contractorAuthService } from '../services/contractorAuthService';

const ContractorProfile: React.FC = () => {
  const contractor = contractorAuthService.getContractorInfo();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const onChangePassword = async () => {
    try {
      setError(null);
      setSuccess(null);
      if (!newPassword || newPassword.length < 8) {
        setError('New password must be at least 8 characters');
        return;
      }
      if (newPassword !== confirmPassword) {
        setError('Passwords do not match');
        return;
      }
      setSaving(true);
      await contractorAuthService.changePassword(currentPassword || undefined, newPassword);
      setSuccess('Password updated successfully');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (e: any) {
      setError(e?.response?.data?.error || e?.message || 'Failed to change password');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: { xs: 2, sm: 4 }, px: { xs: 2, sm: 3 } }}>
      <Typography variant="h4" gutterBottom fontWeight="bold">Profile</Typography>
      <Card>
        <CardContent>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
          <Typography variant="subtitle1" gutterBottom>Account</Typography>
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" color="text.secondary">Name</Typography>
            <Typography variant="body1">{contractor?.name || '-'}</Typography>
          </Box>
          <Box sx={{ mb: 3 }}>
            <Typography variant="body2" color="text.secondary">Email</Typography>
            <Typography variant="body1">{contractor?.email || '-'}</Typography>
          </Box>

          <Typography variant="subtitle1" gutterBottom>Change Password</Typography>
          <TextField
            label="Current Password"
            type="password"
            fullWidth
            sx={{ mb: 2 }}
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
          />
          <TextField
            label="New Password"
            type="password"
            fullWidth
            sx={{ mb: 2 }}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <TextField
            label="Confirm New Password"
            type="password"
            fullWidth
            sx={{ mb: 3 }}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <Button variant="contained" onClick={onChangePassword} disabled={saving} fullWidth>
            {saving ? 'Saving...' : 'Update Password'}
          </Button>
        </CardContent>
      </Card>
    </Container>
  );
};

export default ContractorProfile;


